import { Search } from 'lucide-react';

export function CmdkTrigger({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Buscar"
      title="Buscar (⌘K)"
      className="inline-flex items-center gap-2 h-8 px-2 pl-2.5 bg-bg-card border border-border rounded-md text-fg-subtle text-xs min-w-[260px] hover:border-border-strong hover:text-fg-muted transition-colors duration-fast focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
    >
      <Search size={13} strokeWidth={1.75} />
      <span>Buscar…</span>
      <kbd className="ml-auto text-2xs px-1 py-0.5 bg-bg-muted rounded">⌘K</kbd>
    </button>
  );
}
